import { HalResource } from '../hal/models/HalResource';
import { HierarchyParents } from './HierarchyParents';
import { HierarchyChildren } from './HierarchyChildren';
import { ContentItem } from './ContentItem';
export class HierarchyNode extends HalResource {
    constructor() {
        super(...arguments);
        this.related = {
            contentItem: {
                /**
                 * Retrieve the content item associated with this node
                 */
                get: () => {
                    return this.fetchLinkedResource('content-item', {}, ContentItem);
                },
            },
            children: {
                /**
                 * Retrieve children of the associated node
                 */
                get: () => {
                    return this.fetchLinkedResource('get-hierarchy-children', {}, HierarchyChildren);
                },
            },
            parents: {
                /**
                 * Retrieve parents of the associated node
                 */
                get: () => {
                    return this.fetchLinkedResource('get-hierarchy-parents', {}, HierarchyParents);
                },
            },
        };
    }
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSGllcmFyY2h5Tm9kZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9saWIvbW9kZWwvSGllcmFyY2h5Tm9kZS50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFDQSxPQUFPLEVBQUUsV0FBVyxFQUFFLE1BQU0sMkJBQTJCLENBQUM7QUFDeEQsT0FBTyxFQUFFLGdCQUFnQixFQUFFLE1BQU0sb0JBQW9CLENBQUM7QUFDdEQsT0FBTyxFQUFFLGlCQUFpQixFQUFFLE1BQU0scUJBQXFCLENBQUM7QUFDeEQsT0FBTyxFQUFFLFdBQVcsRUFBRSxNQUFNLGVBQWUsQ0FBQztBQW1ENUMsTUFBTSxPQUFPLGFBQWMsU0FBUSxXQUFXO0lBQTlDOztRQVVTLFlBQU8sR0FBRztZQUNmLFdBQVcsRUFBRTtnQkFDWDs7bUJBRUc7Z0JBQ0gsR0FBRyxFQUFFLEdBQXlCLEVBQUU7b0JBQzlCLE9BQU8sSUFBSSxDQUFDLG1CQUFtQixDQUFDLGNBQWMsRUFBRSxFQUFFLEVBQUUsV0FBVyxDQUFDLENBQUM7Z0JBQ25FLENBQUM7YUFDRjtZQUNELFFBQVEsRUFBRTtnQkFDUjs7bUJBRUc7Z0JBQ0gsR0FBRyxFQUFFLEdBQStCLEVBQUU7b0JBQ3BDLE9BQU8sSUFBSSxDQUFDLG1CQUFtQixDQUM3Qix3QkFBd0IsRUFDeEIsRUFBRSxFQUNGLGlCQUFpQixDQUNsQixDQUFDO2dCQUNKLENBQUM7YUFDRjtZQUNELE9BQU8sRUFBRTtnQkFDUDs7bUJBRUc7Z0JBQ0gsR0FBRyxFQUFFLEdBQThCLEVBQUU7b0JBQ25DLE9BQU8sSUFBSSxDQUFDLG1CQUFtQixDQUM3Qix1QkFBdUIsRUFDdkIsRUFBRSxFQUNGLGdCQUFnQixDQUNqQixDQUFDO2dCQUNKLENBQUM7YUFDRjtTQUNGLENBQUM7SUFDSixDQUFDO0NBQUEifQ==